import React from 'react';
import styled from 'styled-components';
import NumberListItem from './NumberedListItem';
import PropTypes from 'prop-types';

const List = styled('ol')`
  counter-reset: section;
  list-style-type: none;
  padding-left: 0;

  ${({ level }) => {
    return (
      (level === 1 || level === 2) &&
      `
      position: relative;
      left: -50px;

      > li {
         width: calc(100% + 41px);
      }

      @media (max-width: 1192px) {
        left: -44px;
      }

      @media (max-width: 320px) {
         left: -38px;
      }
  `
    );
  }}

  ${({ level }) => {
    return (
      level === 3 &&
      `
      > li {
         width: calc(100% + 18px);
      }

  `
    );
  }}
`;

const DepthContext = React.createContext(0);

const NumberedList = ({ children, simple = false }) => {
  const level = React.useContext(DepthContext);

  return (
    <DepthContext.Provider value={level + 1}>
      <List level={level} simple={simple}>
        {React.Children.map(children, child =>
          React.cloneElement(child, {
            simple:
              simple && !Array.isArray(child.props.children) && level === 0,
            level
          })
        )}
      </List>
    </DepthContext.Provider>
  );
};

NumberedList.Item = NumberListItem;
NumberedList.propTypes = {
  children: PropTypes.node.isRequired,
  simple: PropTypes.bool
};
NumberListItem.defaultProps = {
  simple: false
};

export default NumberedList;
